import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import {
  LayoutDashboard,
  Receipt,
  Package,
  Users,
  FileText,
  FileCheck,
  CreditCard,
  Settings,
  LogOut,
  Menu,
  X,
  UserCog,
  History,
  Building2,
  FileSearch,
  Warehouse,
   Scissors
} from 'lucide-react';


const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
     { path: '/customers', label: 'Clientes', icon: Users },
    { path: '/pos', label: 'Facturar', icon: Receipt },
    { path: '/tailoring-orders', label: 'Pedidos Confección', icon: Scissors },
    { path: '/products', label: 'Productos', icon: Package },
    { path: '/invoices', label: 'Listado Ventas', icon: FileSearch },   
    { path: '/quotations', label: 'Cotizaciones', icon: FileText },     
    { path: '/branch-inventory', label: 'Inventario Sucursal', icon: Warehouse },
    { path: '/inventory-history', label: 'Historial Inventario', icon: History },     
    { path: '/credit-notes', label: 'Notas de Crédito', icon: CreditCard },
    { path: '/reports', label: 'Reportes', icon: FileCheck },
    { path: '/branches', label: 'Sucursales', icon: Building2, adminOnly: true },
    { path: '/users', label: 'Usuarios', icon: UserCog, adminOnly: true },
    { path: '/settings', label: 'Configuración', icon: Settings },
  ];

  // Filtrar menú según rol
  const filteredMenu = menuItems.filter(item => {
    if (item.adminOnly && user?.role !== 'admin') return false;
    return true;
  });

  return (
    <div className="flex h-screen bg-slate-50" data-testid="layout-container">
      {/* Sidebar */}
      <aside
        className={`${
          sidebarOpen ? 'w-64' : 'w-20'
        } bg-slate-900 text-white transition-all duration-300 flex flex-col`}
        data-testid="sidebar"
      >
        <div className="p-4 flex items-center justify-between border-b border-slate-800">
          {sidebarOpen && (
            <h1 className="text-xl font-bold" style={{ fontFamily: 'Outfit' }} data-testid="sidebar-title">
              Batas Médicas RD
            </h1>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="text-white hover:bg-slate-800"
            data-testid="sidebar-toggle"
          >
            {sidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </Button>
        </div>

        <nav className="flex-1 p-4 space-y-2 overflow-y-auto" data-testid="sidebar-nav">
          {filteredMenu.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                  isActive
                    ? 'bg-cyan-500 text-white shadow-md'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                }`}
                data-testid={`nav-link-${item.path.substring(1)}`}
              >
                <Icon className="w-5 h-5" />
                {sidebarOpen && <span className="font-medium">{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-slate-800">
          <div className={`${sidebarOpen ? 'flex items-center space-x-3' : 'flex justify-center'} mb-3`}>
            <div className="w-10 h-10 bg-cyan-500 rounded-full flex items-center justify-center font-bold">
              {user?.name?.[0]?.toUpperCase()}
            </div>
            {sidebarOpen && (
              <div>
                <p className="font-medium" data-testid="user-name">{user?.name}</p>
                <p className="text-xs text-slate-400" data-testid="user-role">{user?.role}</p>
              </div>
            )}
          </div>
          <Button
            onClick={handleLogout}
            variant="ghost"
            className={`${sidebarOpen ? 'w-full' : 'w-10'} text-slate-300 hover:bg-slate-800 hover:text-white`}
            data-testid="logout-button"
          >
            <LogOut className="w-5 h-5" />
            {sidebarOpen && <span className="ml-2">Cerrar Sesión</span>}
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-testid="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
